export default {
      id: "edit_specs-usage",
      viewBox: "0 0 20 17",
      url: __webpack_public_path__ + "img/icons.svg#edit_specs",
      toString: function () {
        return this.url;
      }
    }